export default __webpack_public_path__ + "static/media/arrow-down.bf89deb6.svg";